import { request, METHOD } from '../utils/request.js'

// 记录
export function getAllTestBySnCode(data) {
  return request(
    '/h5Mfitness/com/getAllTestBySnCode',
    METHOD.POST,
    data
  )
}

